/**
 * reportGenerator.js
 * 
 * Generates a 5-page narrative report based on the structure of finalreportex.json
 * AND the 'Antigravity_Master_Text_Bank.txt'.
 */

// =================================================================================
// MASTER TEXT BANK (Embedded for portability)
// =================================================================================
const TEXT_BANK = {
    // PAGE 1: FACE METRICS (Visual Analysis ONLY)
    fWHR: {
        HIGH: {
            desc: "옆광대가 발달하고 가로로 넓게 뻗은 구조",
            analysis: "가로 에너지가 강한 골격이라 시각적으로 꽉 차 보이는 편입니다. 무게중심이 낮고 단단하게 잡혀 있어 안정감이 느껴집니다. 든든한 첫인상을 만들어내는 구조적 특징입니다."
        },
        MID: {
            desc: "균형 잡힌 비율과 모난 곳 없는 구조",
            analysis: "가로와 세로의 비율이 안정된 밸런스를 이루고 있습니다. 어느 한쪽으로 치우치지 않아 시각적으로 편안한 인상을 줍니다. 정석적인 비율이 자연스러운 호감을 만듭니다."
        },
        LOW: {
            desc: "가로폭이 좁고 세로선이 강조된 슬림한 구조",
            analysis: "전체적으로 선이 길고 매끄럽게 흐르는 골격입니다. 군더더기 없는 여백과 날렵한 턱선이 시원한 인상을 줍니다. 개방적이고 세련된 느낌을 만들어내는 구조입니다."
        }
    },
    middleRatio: {
        HIGH: {
            desc: "중안부가 길어 선이 굵어 보이는 특징",
            analysis: "얼굴 중앙부의 비중이 높아 성숙하고 차분한 구조감이 느껴집니다. 시선이 중앙에 머무르게 하는 깊이감이 있습니다. 진중한 첫인상을 만들어내는 비율입니다."
        },
        MID: {
            desc: "가장 표준적이고 현대적인 비례",
            analysis: "이마, 코, 턱의 비율이 보편적인 미적 기준에 부합하는 구조입니다. 시각적으로 편안하고 익숙한 조형미를 보여줍니다. 호감을 주기 쉬운 안정적인 비율입니다."
        },
        LOW: {
            desc: "중안부가 짧고 오밀조밀하게 모인 특징",
            analysis: "얼굴 중앙부가 짧게 압축되어 실제보다 작아 보이는 효과가 있습니다. 전체적으로 밀도 있고 꽉 찬 느낌을 주는 동안 비율입니다. 어려 보이는 인상의 핵심이 되는 구조입니다."
        }
    },
    jawAngle: {
        HIGH: {
            desc: "턱선이 완만하고 곡선이 강조된 윤곽",
            analysis: "하관의 각도가 넓고 둥글게 처리되어 시각적 걸림이 없습니다. 전체적인 얼굴 흐름을 부드럽게 이어주는 유선형 윤곽입니다. 다정하고 편안한 인상을 만들어냅니다."
        },
        MID: {
            desc: "직선과 곡선이 적절히 섞인 표준 윤곽",
            analysis: "턱 끝으로 갈수록 적당히 좁아지면서 각이 살아있는 구조입니다. 날카롭지도 둔탁하지도 않은 명확한 선 처리가 돋보입니다. 상황에 따라 부드럽게도 단단하게도 읽히는 윤곽입니다."
        },
        LOW: {
            desc: "턱선이 예리하고 직선적인 윤곽",
            analysis: "귀 밑에서 턱 끝까지의 각도가 가파르고 선명합니다. 얼굴 하단부를 명확하게 규정짓는 직선적 라인이 특징입니다. 단단하고 의지 있는 첫인상을 만들어내는 구조입니다."
        }
    },
    // PAGE 2: INNER ENGINE (SEB)
    engine: {
        Force: {
            HIGH: "목표가 생기면 빠르게 실행에 옮기는 스타일입니다. 주저하기보다는 결과를 먼저 확인하는 것을 선호합니다. 추진력이 강한 만큼 에너지도 빠르게 전달됩니다.",
            LOW: "서두르기보다 상황을 신중하게 살피는 편입니다. 확실한 근거가 있을 때 움직이며 리스크를 최소화합니다. 빠르진 않지만 정확한 판단이 강점입니다.",
            TYPE_HIGH: "승부욕이 강한 도파민형",
            TYPE_LOW: "평화와 조화를 중시하는 세로토닌형"
        },
        Empathy: {
            HIGH: "주변 상황이나 타인의 기분을 세심하게 파악하는 편입니다. 눈치가 빠르고 분위기를 잘 맞추지만 그만큼 에너지 소모도 있습니다. 배려가 자연스럽게 묻어나는 타입입니다.",
            LOW: "타인의 시선보다 객관적인 사실과 효율을 중시합니다. 감정에 휘둘리지 않고 냉정하게 판단을 내리는 편입니다. 논리적인 사고가 신뢰감을 줍니다."
        },
        Stability: {
            HIGH: "정서적 균형감이 좋고 평정심을 잘 유지합니다. 꾸준하고 일관성 있게 일을 처리하는 힘이 있습니다. 주변에 안정감을 주는 존재입니다.",
            LOW: "환경 변화나 스트레스에 예민하게 반응하는 편입니다. 하지만 그만큼 위험을 미리 감지하는 섬세함이 있습니다. 세심한 대비가 강점이 됩니다."
        }
    },
    // PAGE 3: SYNERGY SCENARIOS
    synergy: {
        TYPE_A: {
            title: "반전의 주도자 (부드러운 인상 + 강한 내면)",
            content: `부드러운 인상 때문에 성격도 유순할 거라 생각하기 쉽습니다.\n하지만 결정적 순간에 단호하고 추진력 있는 면이 드러납니다.\n이 의외성이 상대를 안심시킨 뒤 자연스럽게 상황을 주도하는 힘이 됩니다.`
        },
        TYPE_B: {
            title: "일관된 신뢰 (강한 인상 + 강한 내면)",
            content: `첫인상에서 느껴지는 단단함이 실제 성격과도 일치합니다.\n굳이 설명하지 않아도 무게감이 자연스럽게 전달됩니다.\n이 일관성이 주변에 신뢰와 안정감을 줍니다.`
        },
        TYPE_C: {
            title: "섬세한 통찰 (세련된 인상 + 신중한 내면)",
            content: `겉으로 보이는 지적인 분위기만큼 내면의 생각도 깊고 촘촘합니다.\n남들이 놓치기 쉬운 세밀한 부분까지 파악하는 편입니다.\n판을 읽고 설계하는 역할에서 대체 불가능한 존재감을 보여줍니다.`
        },
        TYPE_D: {
            title: "따뜻한 중재자 (강한 인상 + 부드러운 내면)",
            content: `강한 인상 때문에 다가가기 어려워 보이지만, 알고 보면 배려심 깊은 반전이 있습니다.\n이 갭을 알게 된 사람들은 '진국이다'라는 평가를 내리는 편입니다.\n무표정의 무게감 속에 작은 챙김이 더해지면 감동이 배가 됩니다.`
        },
        TYPE_E: {
            title: "유연한 밸런서 (균형 잡힌 인상 + 유연한 내면)",
            content: `어느 한쪽으로 치우치지 않아 어디에나 자연스럽게 녹아드는 적응력이 있습니다.\n상황에 따라 강함과 부드러움을 유연하게 오갈 수 있습니다.\n이 유연함이 다양한 관계에서 편안한 존재감을 만들어냅니다.`
        }
    },
    // PAGE 4 & 5: STRATEGY
    strategy: {
        detailed_image: {
            hair_frame: {
                WIDE_FACE: "가로폭이 넓은 편이므로 윗머리 볼륨을 살리고 옆머리를 정리하는 스타일이 잘 어울립니다. 이마를 시원하게 드러내면 세로 비율이 살아납니다. 리젠트나 포마드 계열을 추천합니다.",
                NARROW_FACE: "갸름한 편이므로 옆머리에 약간의 볼륨을 주면 인상이 부드러워집니다. 가르마 펌이나 쉐도우 펌으로 가로 확장을 유도해보세요. 자연스러운 컬이 얼굴의 여백을 채워줍니다.",
                LONG_MID: "중안부가 긴 편이므로 앞머리로 이마를 살짝 가리는 것이 동안 효과를 줍니다. 가일 컷이나 애즈 펌처럼 시선을 분산시키는 스타일을 추천합니다. 완전히 드러내기보다 살짝 커버하는 것이 좋습니다.",
                SHORT_MID: "중안부가 짧아 어려 보이므로 이마를 드러내는 스타일이 성숙함을 더해줍니다. 아이비리그 컷이나 짧은 기장감이 잘 어울립니다. 깔끔하게 정리할수록 균형이 좋아집니다."
            },
            fashion_mood: {
                SOFTEN: "강한 골격을 중화하려면 캐시미어 니트나 린넨 셔츠 같은 부드러운 소재가 효과적입니다. 라운드 넥이나 브이넥으로 여유를 주면 인상이 편안해집니다. 소재의 질감으로 온도차를 만들어보세요.",
                SHARPEN: "부드러운 인상에 무게감을 더하려면 각이 잡힌 자켓이나 옥스포드 셔츠를 추천합니다. 넥타이나 행커치프 같은 직선적 액세서리도 잘 어울립니다. 구조감 있는 아이템이 인상에 힘을 더해줍니다.",
                BALANCE: "어떤 옷이든 잘 어울리는 편이지만, 세미 오버핏 셋업이 특히 잘 맞습니다. 트렌디함과 단정함을 동시에 챙길 수 있습니다. 정돈된 실루엣이 밸런스를 돋보이게 합니다."
            },
            accessory: {
                ROUND: "각진 얼굴선을 보완하려면 하금테나 원형 메탈 프레임 안경이 좋습니다. 지적이면서도 부드러운 느낌을 더해줍니다. 곡선 요소가 인상의 균형을 맞춰줍니다.",
                RECT: "둥근 얼굴선에 긴장감을 주려면 스퀘어 뿔테나 직사각형 메탈 안경을 추천합니다. 이지적인 느낌을 자연스럽게 연출할 수 있습니다. 직선 요소가 인상에 힘을 실어줍니다.",
                NONE: "안경보다는 시계나 팔찌 같은 손목 액세서리가 잘 어울립니다. 제스처를 취할 때마다 은은한 포인트가 됩니다. 과하지 않은 디테일이 고급스러움을 만들어냅니다."
            }
        },
        behavior_tactic: {
            HIGH_FORCE: "에너지가 이미 충분히 강합니다. 제스처를 조금 느리게 하고 여유로운 자세를 유지해보세요. 힘을 빼는 모습이 오히려 여유로운 매력으로 보입니다.",
            LOW_FORCE: "섬세함이 위축되어 보이지 않도록 보폭을 조금 넓히고 어깨를 펴보세요. 시선을 상대의 미간에 고정하는 연습이 효과적입니다. 작은 변화만으로도 존재감이 달라집니다.",
            HIGH_EMPATHY: "과도한 리액션은 가벼워 보일 수 있습니다. 고개 끄덕이는 횟수를 줄이고 입가에 옅은 미소만 유지해보세요. 절제된 반응이 오히려 깊은 인상을 줍니다.",
            LOW_EMPATHY: "논리적인 말하기에 쿠션 언어를 한 스푼 더해보세요. 용건 전에 가벼운 질문 하나를 먼저 건네는 루틴이 효과적입니다. 작은 배려가 소통을 부드럽게 만듭니다."
        },
        situation: {
            HARD_CONV: "무리한 요구에는 바로 대답하지 말고 잠시 가만히 바라보세요. 화를 내지 않아도 진중한 태도가 상대를 돌아보게 합니다. 침묵이 가장 효과적인 대응이 될 때가 있습니다.",
            RELATION: "처음부터 기준과 선호도를 자연스럽게 밝혀보세요. 쉽게 접근하려는 사람을 미리 걸러낼 수 있습니다. 명확한 기준이 오히려 좋은 관계를 만들어줍니다.",
            STRESS: "생각이 꼬일 때는 고민을 멈추고 당장 할 수 있는 작은 일부터 시작해보세요. 머리로 고민할 때보다 움직일 때 답을 찾기 쉬운 타입입니다. 작은 행동이 흐름을 바꿔줍니다."
        }
    }
};

export const generateNarrativeReport = (mega, face, stats) => {
    // Safety Checks
    const hasMega = !!mega;
    const hasFace = !!face;

    if (!hasMega && !hasFace) return null;

    // --- Data Extraction ---
    // Mega (Inner)
    const scoreSeb = mega?.summary?.score_seb || mega?.score_seb || {};
    const S = scoreSeb.S || 50; // Stability
    const E = scoreSeb.E || 50; // Empathy
    const F = scoreSeb.F || 50; // Force

    // Face (Outer)
    // Assuming backend returns percentiles. We map them to High/Mid/Low roughly.
    // 0-33: Low, 34-66: Mid, 67-100: High
    // Exception: Jaw Angle often inverse or specific. Let's stick to simple logic or label if available.

    const labels = face?.labels || {};

    // Helper to map labels or values to HIGH/MID/LOW
    const getLevel = (key, val) => {
        if (labels[key]) return labels[key]; // If backend label exists (e.g., "HIGH")
        if (val === undefined) return "MID";
        if (val >= 67) return "HIGH";
        if (val <= 33) return "LOW";
        return "MID";
    };

    const fwhrLevel = getLevel("fWHR", face?.fwhr_percentile); // Assuming percentile available or just label
    const midRatioLevel = getLevel("Middle Face Ratio", face?.mid_face_ratio_percentile);
    const jawLevel = getLevel("Jaw Angle", face?.jaw_angle_percentile);

    const isFeminine = face?.masculinity_percentile < 40;
    const isMasculine = face?.masculinity_percentile > 60;

    const pages = [];

    // =================================================================================
    // [PAGE 1] 얼굴 지표 (Face Metrics) - Visual Analysis
    // =================================================================================
    let p1_content = "";

    // 1-1. fWHR
    const fData = TEXT_BANK.fWHR[fwhrLevel] || TEXT_BANK.fWHR.MID;
    p1_content += `**1. 골격의 안정감**: ${fData.analysis}\n(${fData.desc})\n\n`;

    // 1-2. Middle Ratio
    const mData = TEXT_BANK.middleRatio[midRatioLevel] || TEXT_BANK.middleRatio.MID;
    p1_content += `**2. 인상의 무게**: ${mData.analysis}\n(${mData.desc})\n\n`;

    // 1-3. Jaw Angle
    const jData = TEXT_BANK.jawAngle[jawLevel] || TEXT_BANK.jawAngle.MID;
    p1_content += `**3. 인상의 온도**: ${jData.analysis}\n(${jData.desc})`;

    pages.push({
        id: 1,
        title: "나의 타고난 얼굴 설계도",
        subtitle: "얼굴 지표 심층 분석",
        content: p1_content,
        color: "#60a5fa"
    });

    // =================================================================================
    // [PAGE 2] 내면 엔진 (SEB)
    // =================================================================================
    let p2_content = "";

    // Force
    const fKey = F >= 60 ? "HIGH" : (F <= 40 ? "LOW" : "MID");
    const fTypeDesc = F >= 60 ? TEXT_BANK.engine.Force.TYPE_HIGH : (F <= 40 ? TEXT_BANK.engine.Force.TYPE_LOW : "밸런스형 엔진");
    const fDesc = TEXT_BANK.engine.Force[fKey] || "상황에 따라 유연하게 대처하는 밸런스형입니다.";

    p2_content += `**1. 추진력 (Force)**: ${fTypeDesc}\n"${fDesc}"\n\n`;

    // Empathy
    const eKey = E >= 60 ? "HIGH" : (E <= 40 ? "LOW" : "MID");
    const eDesc = TEXT_BANK.engine.Empathy[eKey] || "공감과 논리 사이에서 균형을 잡는 편입니다.";
    p2_content += `**2. 공감력 (Empathy)**: \n"${eDesc}"\n\n`;

    // Stability
    const sKey = S >= 60 ? "HIGH" : (S <= 40 ? "LOW" : "MID");
    const sDesc = TEXT_BANK.engine.Stability[sKey] || "적당한 긴장감과 여유를 동시에 가지고 있습니다.";
    p2_content += `**3. 안정성 (Stability)**: \n"${sDesc}"`;

    pages.push({
        id: 2,
        title: "내면의 엔진",
        subtitle: "SEB 기질 및 행동 알고리즘",
        content: p2_content,
        color: "#a78bfa"
    });

    // =================================================================================
    // [PAGE 3] 시너지 서사 (Synergy)
    // =================================================================================
    let p3_data = TEXT_BANK.synergy.TYPE_E; // Default

    // Logic for Types
    if (isFeminine && F >= 60) {
        p3_data = TEXT_BANK.synergy.TYPE_A;
    }
    else if (isMasculine && F >= 60) {
        p3_data = TEXT_BANK.synergy.TYPE_B;
    }
    else if (isMasculine && F <= 40) {
        p3_data = TEXT_BANK.synergy.TYPE_D;
    }
    else if (fwhrLevel === 'LOW' && F <= 40) {
        p3_data = TEXT_BANK.synergy.TYPE_C;
    }

    pages.push({
        id: 3,
        title: "시너지 서사",
        subtitle: p3_data.title,
        content: p3_data.content,
        color: "#fbbf24"
    });

    // =================================================================================
    // [PAGE 4] 이미지 리모델링 (Detailed)
    // =================================================================================
    let p4_content = "";

    // 1. Hair Strategy
    let hairTip = "";
    if (fwhrLevel === 'HIGH') hairTip = TEXT_BANK.strategy.detailed_image.hair_frame.WIDE_FACE;
    else if (midRatioLevel === 'HIGH') hairTip = TEXT_BANK.strategy.detailed_image.hair_frame.LONG_MID;
    else if (midRatioLevel === 'LOW') hairTip = TEXT_BANK.strategy.detailed_image.hair_frame.SHORT_MID;
    else hairTip = TEXT_BANK.strategy.detailed_image.hair_frame.NARROW_FACE;

    p4_content += `**💇 헤어 & 페이스 프레임**\n${hairTip}\n\n`;

    // 2. Fashion Strategy
    let fashionTip = "";
    if (isMasculine) fashionTip = TEXT_BANK.strategy.detailed_image.fashion_mood.SOFTEN;
    else if (isFeminine) fashionTip = TEXT_BANK.strategy.detailed_image.fashion_mood.SHARPEN;
    else fashionTip = TEXT_BANK.strategy.detailed_image.fashion_mood.BALANCE;

    p4_content += `**👔 패션 무드 & 소재**\n${fashionTip}\n\n`;

    // 3. Accessory Strategy
    let accTip = "";
    if (fwhrLevel === 'HIGH' || jawLevel === 'HIGH') accTip = TEXT_BANK.strategy.detailed_image.accessory.ROUND; // Strong bones -> Soft glasses
    else if (isFeminine || jawLevel === 'LOW') accTip = TEXT_BANK.strategy.detailed_image.accessory.RECT; // Soft face -> Sharp glasses
    else accTip = TEXT_BANK.strategy.detailed_image.accessory.NONE;

    p4_content += `**👓 킥 아이템 (Accessory)**\n${accTip}\n\n`;

    // 4. Behavior Strategy
    let actionTip = "";
    if (F >= 60) actionTip = TEXT_BANK.strategy.behavior_tactic.HIGH_FORCE;
    else actionTip = TEXT_BANK.strategy.behavior_tactic.LOW_FORCE;

    // Add Empathy tip if relevant
    if (E >= 60 && F < 60) actionTip += `\n\n또한, ${TEXT_BANK.strategy.behavior_tactic.HIGH_EMPATHY}`;
    else if (E <= 40 && F >= 60) actionTip += `\n\n추가로, ${TEXT_BANK.strategy.behavior_tactic.LOW_EMPATHY}`;

    p4_content += `**🎭 행동 제스처 (Gesture)**\n${actionTip}`;

    pages.push({
        id: 4,
        title: "이미지 리모델링",
        subtitle: "Visual & Behavioral Optimization",
        content: p4_content,
        color: "#f87171"
    });

    // =================================================================================
    // [PAGE 5] 실전 필살기
    // =================================================================================
    let p5_content = "";
    p5_content += `**어려운 대화**: ${TEXT_BANK.strategy.situation.HARD_CONV}\n\n`;
    p5_content += `**관계 설정**: ${TEXT_BANK.strategy.situation.RELATION}\n\n`;
    p5_content += `**스트레스 관리**: ${TEXT_BANK.strategy.situation.STRESS}`;

    pages.push({
        id: 5,
        title: "실전 가이드",
        subtitle: "일상에서 활용할 수 있는 팁",
        content: p5_content,
        color: "#34d399"
    });

    return pages;
};
